import Head from 'next/head';

interface Props {
  title?: string;
  description?: string;
  image?: string;
}

export const PageSocialMeta = ({ title, description, image }: Props) => {
  return (
    <Head>
      <meta property="og:type" content="website" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
    </Head>
  );
};
